/**
 * Admin BrandMark — same look as web/marketing/BrandMark but no locale
 * dependency (admin is always Chinese).
 */

interface BrandMarkProps {
  withEmoji?: boolean;
  emojiClassName?: string;
  textClassName?: string;
}

export function BrandMark({
  withEmoji = true,
  emojiClassName = 'text-xl',
  textClassName = 'font-display font-bold text-white tracking-tight',
}: BrandMarkProps): JSX.Element {
  return (
    <span className="inline-flex items-center gap-2">
      {withEmoji && <span className={emojiClassName}>🦈</span>}
      <span className={textClassName}>
        小鲨鱼 <span className="text-shark-400 font-semibold ml-0.5">Admin</span>
      </span>
    </span>
  );
}
